/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { normalizeLabel } from 'app/gamma/src/api/normalizers/label';
// eslint-disable-next-line no-restricted-imports
import type { LabelModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import type { LabelResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from '@trello/redux';
import type { PerformSearchSuccessAction } from 'app/src/components/ReduxSearch/search-actions';
import { PERFORM_SEARCH_SUCCESS } from 'app/src/components/ReduxSearch/search-actions';

// Reducer
export interface LabelState {
  [labelId: string]: LabelModel;
}

const initialState: LabelState = {};

export default createReducer(initialState, {
  [PERFORM_SEARCH_SUCCESS](
    state: LabelState,
    { payload }: PerformSearchSuccessAction,
  ) {
    if (!payload.cards) {
      return state;
    }

    return payload.cards
      .reduce(
        (allLabels, card) => allLabels.concat(card.labels || []),
        [] as LabelResponse[],
      )
      .reduce((endState, label) => {
        if (!endState[label.id]) {
          endState[label.id] = normalizeLabel(label);
        }

        return endState;
      }, state);
  },
});
